import React from 'react';
import { useTheme } from '@mui/material/styles';
import SvgIcon from '@mui/material/SvgIcon';

function Competency(props) {
    const theme = useTheme();
    return (
        <SvgIcon viewBox="0 0 48 48" {...props}>
            <g id="CompetencyIcon">
                <path
                    fill={theme.palette.secondary.dark}
                    stroke={theme.palette.secondary.dark}
                    d="M36.86,1H16.39a1.08,1.08,0,0,0-.76.31l-9.58,9.6a1.12,1.12,0,0,0-.33.75v30A5.41,5.41,0,0,0,11.14,47H36.86a5.41,5.41,0,0,0,5.42-5.36V6.36A5.41,5.41,0,0,0,36.86,1ZM15.3,4.68V8a2.56,2.56,0,0,1-2.56,2.56H9.43Zm24.83,37a3.25,3.25,0,0,1-3.27,3.21H11.15a3.26,3.26,0,0,1-3.27-3.21V12.72h4.86A4.71,4.71,0,0,0,17.45,8V3.15H36.86a3.26,3.26,0,0,1,3.27,3.21Zm0,0" />
                <path
                    fill={theme.palette.primary.main}
                    d="M30.21,20a6.21,6.21,0,0,1-12.42,0,6.57,6.57,0,0,1,.37-2.15c0-.05.05-.09.07-.14a6.21,6.21,0,0,1,12,2.29ZM23.06,11.7A8.34,8.34,0,0,0,15.69,20,8.1,8.1,0,0,0,17.44,25l1.11,1.43-.43,8.44V35a1.35,1.35,0,0,0,.77,1.21A1.3,1.3,0,0,0,20.3,36L24,32.78,27.7,36a1.38,1.38,0,0,0,.86.33,1.23,1.23,0,0,0,.54-.13,1.33,1.33,0,0,0,.77-1.2l-.38-8.79A8.3,8.3,0,0,0,32.31,20h0a8.28,8.28,0,0,0-7.16-8.22Zm4.65,21.52-2.82-2.44a1.3,1.3,0,0,0-1.78,0l-2.82,2.44.24-5.7a8.25,8.25,0,0,0,6.94,0Zm0,0" />
                <path
                    fill={theme.palette.primary.main}
                    d="M19.92,20A4.08,4.08,0,1,0,24,15.89,4.08,4.08,0,0,0,19.92,20ZM26,20a2,2,0,1,1-2-2,2,2,0,0,1,2,2Zm0,0" />
            </g>
        </SvgIcon>
    );
}

export default Competency;